
import { ProgramCategory } from '../types';

export enum EnrollmentEventType {
  NEW_ENROLLMENT = 'new_enrollment',
  PROGRAM_TRANSFER = 'program_transfer',
  STATUS_CHANGE = 'status_change',
  WITHDRAWAL = 'withdrawal',
  RE_ENROLLMENT = 're_enrollment'
}

export enum EnrollmentStatus {
  ACTIVE = 'active',
  ON_HOLD = 'on_hold',
  COMPLETED = 'completed',
  WITHDRAWN = 'withdrawn'
}

export interface EnrollmentEvent {
  id: string;
  studentId: number;
  programId?: string;
  eventType: EnrollmentEventType;
  timestamp: string;
  details: EnrollmentEventDetails;
}

export interface EnrollmentEventDetails {
  // Base properties
  programCategory?: ProgramCategory;
  programTitle?: string;
  
  // For status changes
  previousStatus?: EnrollmentStatus;
  newStatus?: EnrollmentStatus;
  
  // For transfers
  fromProgram?: {
    category: ProgramCategory;
    title: string;
  };
  toProgram?: {
    category: ProgramCategory;
    title: string;
  };
  
  // For withdrawals/dropouts
  reason?: string;
  
  // For re-enrollments
  previousEnrollmentDate?: string;
  
  // Additional notes
  notes?: string;
}
